import {ADICIONAR_FILTRO_AGENCIA, LISTAR_FILTROS_AGENCIA, REMOVER_FILTRO_AGENCIA} from '../../actions/types'
import {filtroExiste} from '../../util/filtros'

const initialState = undefined

const initial = {
}

export const filtrosAdicionadosAgencia = (state = [], action = initialState) => {
  switch (action.type) {
    case ADICIONAR_FILTRO_AGENCIA: {
      if (!filtroExiste(state, action.payload)) {
        return state.concat(action.payload)
      }
      return state
    }

    case REMOVER_FILTRO_AGENCIA: {
      const copia = [...state]
      return copia.filter(filtro => filtro.chave !== action.payload.chave || filtro.valor !== action.payload.valor)
    }

    default:
      return state
  }
}

export const filtrosAgencia = (state = initial, action) => {
  switch (action.type) {
    case LISTAR_FILTROS_AGENCIA: {
      return action.payload.data
    }
    default:
      return state
  }
}
